import { isAbsent } from '../../../utils/metricFormat';

// The results page's headline numbers, all from ONE basis, which the page names (DWLF-306/311).
// Every value is the API's; an absent one stays null and renders as "—" (charter invariant 8).
// Percent fields are in percent units (27.45 = 27.45%).

const num = (v) => (isAbsent(v) ? null : Number(v));
const pctFromDecimal = (v) => (isAbsent(v) ? null : Number(v) * 100);

export function headlineFrom(resultsData, { perSymbol = false } = {}) {
  if (!resultsData) return null;
  const pp = perSymbol ? null : resultsData.portfolioPerformance;
  if (pp) {
    return {
      basis: 'Portfolio · one shared account',
      returnPct: num(pp.totalReturnPercent), returnAbs: num(pp.totalReturn), maxDrawdownPct: num(pp.maxDrawdownPercent),
      winRatePct: num(pp.winRate), wins: num(pp.winningTrades), trades: num(pp.totalTrades),
      profitFactor: num(pp.profitFactor), sharpe: num(pp.sharpeRatio), cagrPct: num(pp.cagr),
    };
  }
  const perf = perSymbol ? null : resultsData.performance;
  if (perf) { // multi-symbol run without portfolio mode: the merged equal-weight view (decimals)
    return {
      basis: 'Equal-weight across symbols',
      returnPct: pctFromDecimal(perf.totalReturnPercent), returnAbs: num(perf.totalReturn), maxDrawdownPct: pctFromDecimal(perf.maxDrawdownPercent),
      winRatePct: pctFromDecimal(perf.winRate), wins: null, trades: num(resultsData.totalTrades),
      profitFactor: num(perf.profitFactor), sharpe: num(perf.sharpeRatio), cagrPct: null,
    };
  }
  return {
    basis: `This symbol · ${resultsData.symbol || ''}`.trim(),
    returnPct: num(resultsData.totalReturnPercent), returnAbs: num(resultsData.totalReturn), maxDrawdownPct: num(resultsData.maxDrawdownPercent),
    winRatePct: num(resultsData.winRate), wins: num(resultsData.winningTrades), trades: num(resultsData.totalTrades),
    profitFactor: num(resultsData.profitFactor), sharpe: num(resultsData.sharpeRatio), cagrPct: null,
  };
}

/**
 * A list row's headline from the summary results (`?summary=true`, `data.results`): the portfolio
 * block when the run had one, else the single symbol's row, else the API's aggregate across symbols.
 * Never aggregated here: a list figure is the API's or absent.
 */
export function rowHeadline(results) {
  const rows = Array.isArray(results) ? results : [];
  if (rows.length === 0) return null;
  const first = rows[0];
  if (first.portfolioPerformance) return headlineFrom({ portfolioPerformance: first.portfolioPerformance });
  if (rows.length === 1) return headlineFrom(first);
  const agg = first.aggregatePerformance || {};
  return {
    basis: 'Aggregate across symbols',
    returnPct: num(agg.totalReturnPercent ?? agg.averageReturn), returnAbs: num(agg.totalReturn), maxDrawdownPct: num(agg.maxDrawdownPercent),
    winRatePct: num(agg.winRate ?? agg.averageWinRate), wins: num(agg.winningTrades), trades: num(agg.totalTrades),
    profitFactor: num(agg.profitFactor), sharpe: num(agg.sharpeRatio), cagrPct: null,
  };
}
